import React from 'react'
import { get, repeat, forEach } from 'lodash-es'
function formatPartialCardNumber(cardNumberSuffix, dotLength = 2) {
  if(!cardNumberSuffix) return ''
  return `${repeat('•', dotLength)}${cardNumberSuffix}` // FIXME i18n, RTL!
}

function formatLongCardNumber(cardNumberSuffix) {
  return `**** **** **** ${cardNumberSuffix}` // FIXME i18n, RTL!
}

function formatCVC(cardVerificationCode, isCardLocked) {
  return isCardLocked ? `${repeat('•', cardVerificationCode.length)}` : cardVerificationCode
}

/**
 * @param {string} cardNumber - 1234432112344321
 * @return {string} 1234 4321 1234 4321
 *
 */
function formatCompleteCardNumber(cardNumber) {
  return cardNumber && cardNumber.match(/.{1,4}/g).join(' ')
}

/**
 * @param {string} expiryDate YYMM format
 * @return {object} { cardExpiryMonth, cardExpiryYear }
 */
function extractCardExpiryParts(expiryDate) {
  let cardExpiryMonth = ''
  let cardExpiryYear = ''

  if (expiryDate && /^\d{4}$/.test(expiryDate)) {
    cardExpiryYear = expiryDate.substr(0, 2)
    cardExpiryMonth = expiryDate.substr(2)
  }

  return { cardExpiryMonth, cardExpiryYear }
}

/**
 * @param {string} expiryDate YYMM format
 * @return {string} format: MM/YY
 *
 */
function formatExpiryDate(expiryDate = '') {
  return expiryDate.substr(2) + '/' + expiryDate.substr(0, 2)
}

function formatInstrumentNames(card) {
  const instruments = get(card, 'pinDetails.accessInstruments')
  if (!instruments) {
    return ''
  }
  const names = instruments.map((obj) => obj.legalProductName)
  const nameLength = names.length
  if (nameLength > 1) {
    return names.slice(0, nameLength - 1).join(', ') + ` or ` + names[nameLength - 1]
  }
  return names[0]
}

function emToStrongFormatter() {
  const formatProps = {
    em(s) {
      return <strong>{s}</strong>
    },
  }
  return formatProps
}

/**
 * @param {iterable} An iterable such as an object or array
 * @return {null} Mutates iterable in place by parsing JSON strings where it exist
 *
 */
function safeParseJSONInCollection(items) {
  if (!items) return
  forEach(items, (value, i) => {
    try {
      items[i] = JSON.parse(value)
    } catch {
      // do nothing
    }
  })
}

export {
  formatPartialCardNumber,
  formatLongCardNumber,
  formatCompleteCardNumber,
  formatExpiryDate,
  formatInstrumentNames,
  extractCardExpiryParts,
  emToStrongFormatter,
  safeParseJSONInCollection,
  formatCVC,
}
